import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardPage from "layouts/DashboardPage/DashboardPage";
import ProductGroupsList from "modules/productGroups/ProductGroupsList";
import { Link } from "react-router-dom";
import { getRoute } from "utils/routing";

export default function ProductGroupsPage() {
  return (
    <DashboardPage>
      <MDBox mb={6}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MDTypography variant="h4" fontWeight="medium">
              Product Groups
            </MDTypography>
          </Grid>
          <Grid item xs={12} lg={6} display="flex" justifyContent="flex-end">
            <MDButton component={Link} type="button" to="/product-groups/create" color="blue">
              Create Product Group
            </MDButton>
          </Grid>
        </Grid>
      </MDBox>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ProductGroupsList />
        </Grid>
      </Grid>
    </DashboardPage>
  );
}
